import type { JSONSchema7 } from 'json-schema';

export type EntityDescriptionUiOptions = {
  /** Name of the form field holding the entity ref to describe. */
  entityField: string;
};

export const EntityDescriptionSchema = {
  uiOptions: {
    type: 'object',
    required: ['entityField'],
    properties: {
      entityField: {
        type: 'string',
        title: 'Entity field',
        description:
          'Name of the form field (usually an EntityPicker) whose selected entity description is shown',
      },
    },
  } as JSONSchema7,
  returnValue: {
    title: 'Unused',
    type: 'string',
  } as JSONSchema7,
};
